import React, {Component} from 'react';
import {Col, Row, Button, ControlLabel, FormControl} from 'react-bootstrap';
import Datetime from 'react-datetime'
import moment from 'moment'
import _ from 'lodash'
import Select   from 'react-select'
import config from  '../../../../config';
import {
    ADD_SELECTED_TRANSACTIONS, CLEAR_SELECTED_TRANSACTIONS, UPDATE_TRANSACTION_DATA
} from "actions/actionTypes";


export default class ContractorTransactionsSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        // var ContractorID ={ }
        //   if (this.props.adminTransactions.fetched && this.props.adminTransactions.ContractorID && this.props.adminTransactions.total >0) {
        //     ContractorID =  {value:  this.props.adminTransactions.data[0].ContractorID._id,  label:this.props.adminTransactions.data[0].ContractorID.DisplayName}
        // } else{
        //      ContractorID =  {value: 'all', label: 'All'}
        //  }
        var Statuses =_.isUndefined(this.props.location.query.Statuses) ? [ {value: 'PendingPayout', label: 'Pending Payout'}] : _.isArray(this.props.location.query.Statuses) ? _.map(this.props.location.query.Statuses, function (status) {
            return _.find(config.transactionStatusMap, {value:status})
        }) : [_.find(config.transactionStatusMap, {value:this.props.location.query.Statuses})]
        if (_.size(_.get(this.props.location.query, 'recordIDs', []))  ){
            Statuses = []
           // Types=[]
        }
         this.state = {

            filterOptions: {
                 perPage: _.isUndefined(this.props.location.query.perPage) ? config.table.numberPerPage : this.props.location.query.perPage,
                TransactionNumber: _.isUndefined(this.props.location.query.TransactionNumber) ? '' : this.props.location.query.TransactionNumber,
                ContractorID: _.isUndefined(this.props.location.query.ContractorID) ? null : this.props.location.query.ContractorID,
                Statuses:Statuses  ,
                ContractorTypes:  _.isUndefined(this.props.location.query.ContractorTypes) ? [  ] : _.isArray(this.props.location.query.ContractorTypes) ? _.map(this.props.location.query.Types, function (value) {
                    return _.find([{value:'Contractor', label:'Contractor',} ,{value:'Employee', label:'Employee',}], {value:value})
                }) : [_.find([{value:'Contractor', label:'Contractor',} ,{value:'Employee', label:'Employee',}], {value:this.props.location.query.ContractorTypes})],
                fromDateWorked:_.isUndefined(this.props.location.query.fromDateWorked) ? '' : moment(this.props.location.query.fromDateWorked),
               toDateWorked:_.isUndefined(this.props.location.query.toDateWorked) ? '' : moment(this.props.location.query.toDateWorked),
                fromPD:_.isUndefined(this.props.location.query.fromPD) ? '' : moment(this.props.location.query.fromPD),
                toPD:_.isUndefined(this.props.location.query.toPD) ? '' : moment(this.props.location.query.toPD),

                Deleted: _.isUndefined(this.props.location.query.Deleted) ? 'false' : this.props.location.query.Deleted,
                advancedOptionsVisible: false,
                 searchText:  _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,
                Markets:_.isUndefined(this.props.location.query.Markets) ? [] : _.map(this.props.location.query.Markets.split(','), function (item) {
                    var location = _.find(config.warehouseData, function (o) {
                        return o.MarketName == item
                    });
                    if (location) {
                        return {'value': item, 'label': location.MarketName}
                    }
                }),
                recordIDs:  _.isUndefined(this.props.location.query.recordIDs) ?  [] : _.isArray(this.props.location.query.recordIDs) ?  _.get(this.props.location.query, 'recordIDs', []) : [_.get(this.props.location.query, 'recordIDs')]

                //   fromCreateTimeDisplay: _.isUndefined(this.props.location.query.from) ? '' : moment(this.props.location.query.from).format("MM-DD-YYYY"),
                //   toCreateTimeDisplay: _.isUndefined(this.props.location.query.to) ? '' : moment(this.props.location.query.to).format("MM-DD-YYYY"),
            }
        };


    };

    componentWillReceiveProps(nextProps) {


    }


    setSearchParams(params) {
         if ( params.ContractorID !== this.state.filterOptions.ContractorID){
            this.props.fetchSelectedUserData(params.ContractorID)
        }
        this.setState({filterOptions: {...this.state.filterOptions, ...params}});
    }

    resetSearchParams() {
        this.setState({
            filterOptions: {
                perPage:   config.table.numberPerPage,
                TransactionNumber: '',
                Statuses: [ {value: 'Sold', label: 'Sold'}],
                fromDateWorked: '',
                toDateWorked: '',
                fromPD: '',
                toPD: '',
                ContractorID: null,
                PaymentMethod:null,
                Deleted:'false',
            }
        }, function () {

            this.props.resetSearch();
        });

    }




    onMarketsSelect(options) {
        var updateOptions = {...this.state.filterOptions, Markets: options};
        this.setState({'filterOptions': updateOptions}, function () {
            this.props.search();
        });
    }
    getSearchParams(filtersChanged = {}) {
        var filterOptions = {...this.state.filterOptions, ...filtersChanged};

        var queryParams = {Types:[
            'WorkingTime',
            'PayBonus'
        ]};

        if (!_.isUndefined(filterOptions.Statuses)) {
            queryParams.Statuses = _.map(filterOptions.Statuses, 'value')
        }

        if (filterOptions.PaymentMethod) {
            queryParams.PaymentMethod = filterOptions.PaymentMethod;
        }
        if (filterOptions.ContractorID) {
            queryParams.ContractorID = filterOptions.ContractorID;
        }
        if (_.get(filterOptions,'Deleted', '') =='true') {
            queryParams.Deleted = filterOptions.Deleted;
        }
        if (_.size(filterOptions.recordIDs) > 0) {
            queryParams.recordIDs = filterOptions.recordIDs
            queryParams.all= true;
        }
        if (filterOptions.OrderNumber) {
            queryParams.OrderNumber = filterOptions.OrderNumber;
        }
        if (filterOptions.searchText) {
            queryParams.searchText = filterOptions.searchText;
        }
        if (_.size(filterOptions.Markets) > 0) {
            queryParams.Markets = _.map(filterOptions.Markets, 'value').join(',')
        }
        if (_.size(filterOptions.ContractorTypes) > 0) {
            queryParams.ContractorTypes = _.map(filterOptions.ContractorTypes, 'value').join(',')
        }
        if (filterOptions.perPage == 'all') {
            queryParams.all = true
        } else {
            queryParams.perPage = filterOptions.perPage;
        }
        if (filterOptions.fromDateWorked &&  moment(filterOptions.fromDateWorked, 'MM-DD-YYYY HH:mm',true).isValid() ) {
            queryParams.fromDateWorked = filterOptions.fromDateWorked.toISOString()
        }
         if (filterOptions.toDateWorked &&  moment(filterOptions.toDateWorked, 'MM-DD-YYYY HH:mm',true).isValid()  ) {
            queryParams.toDateWorked = filterOptions.toDateWorked.toISOString()
        }
        if (filterOptions.fromPD &&  moment(filterOptions.fromPD, 'MM-DD-YYYY HH:mm',true).isValid() ) {
            queryParams.fromPD = filterOptions.fromPD.toISOString()
        }
        if (filterOptions.toPD &&  moment(filterOptions.toPD, 'MM-DD-YYYY HH:mm',true).isValid()  ) {
            queryParams.toPD = filterOptions.toPD.toISOString()
        }


        return {queryParams}
    }

    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.search();
        }
    }


    onSelectAllRecordsChange() {
        var self = this;
        if (self.props.adminTransactions.selectedTransactions.length == 0) {

            this.props.search({include: ['_id'], all: true}).then(response => {
                this.props.toggleAllRecordsSelection(true)

                self.props.dispatchAction(response.data.data, ADD_SELECTED_TRANSACTIONS)
            });
        } else {
            this.props.toggleAllRecordsSelection(false);

            this.props.dispatchAction({}, CLEAR_SELECTED_TRANSACTIONS)
        }
    }

    // displayFoundContractorsDisplayNames(){
    //      return _.map(this.props.foundContractorsList, function (record) {
    //         return (<span key={record.value} onClick={(e)=>this.props.search({'ContractorID':record.value})} className="contractor-select-button">{record.label}</span>);
    //     }.bind(this))
    // }
    render() {
         var self = this;
         return (
            <div className="transaction-search-block bot15">

                <Row className="top10">

                    <Col xs={9} sm={4} md={4} lg={3} className=" top10">
                        <ControlLabel>Contractor</ControlLabel>
                        <Select
                            tabIndex="0"
                            searchable={true}
                            selectedOptions
                            clearable={true}
                            placeholder=""
                               options={_.filter(this.props.contractorsOptionsList,item=>{
                                 if (_.size(_.get(this.state.filterOptions,'ContractorTypes',[]))){
                                      return _.includes(_.map(this.state.filterOptions.ContractorTypes, 'value'),item.Type)
                                 }else {
                                     return item
                                 }
                               })
                               }
                            // options={ this.props.foundContractorsList }
                            onChange={ (selectedOption) => {
                                console.log('selectedOption',selectedOption );
                                this.props.fetchSelectedUserData(selectedOption ?  selectedOption.value : null)

                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        ContractorID:  selectedOption ?  selectedOption.value : null,
                                    }
                                }, function () {
                                    this.props.search();
                                })
                            }}
                             value={this.state.filterOptions.ContractorID}
                        />

                    </Col>

                    <Col xs={9}  sm={4}  md={4} lg={3}   className="top10">
                        <ControlLabel>Payment Status</ControlLabel>
                        <Select
                            tabIndex="0"
                            multi
                            placeholder=""
                            clearable={true}
                            options={_.filter(config.transactionStatusMap, item=>{
                                return _.includes(['Pending', 'PendingPayout', 'Paid'], item.value)
                            })
                            }
                            onChange={(selectedOptions)=> {
                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        Statuses: selectedOptions
                                    }
                                }, function () {
                                    this.props.search();
                                });
                            }}
                            value={self.state.filterOptions.Statuses}
                        />
                    </Col>
                    <Col xs={9}  sm={4}  md={4} lg={3}   className="top10">
                        <ControlLabel>Type</ControlLabel>
                        <Select
                            tabIndex="0"
                            multi
                            placeholder=""
                            clearable={true}
                            options={ [{value:'Contractor', label:'Contractor',} ,{value:'Employee', label:'Employee',} ]}

                            onChange={(selectedOptions)=> {
                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        ContractorTypes: selectedOptions
                                    }
                                }, function () {
                                    this.props.search();
                                });
                            }}
                            value={self.state.filterOptions.ContractorTypes}
                        />
                    </Col>
                    <Col xs={9} sm={4} md={4} lg={3} className="top10">
                        <ControlLabel>Search</ControlLabel>
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.searchText}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                     onChange={(event) => {
                                         this.setState({
                                             'filterOptions': {
                                                 ...this.state.filterOptions,
                                                 searchText: event.target.value
                                             }
                                         })
                                     }}
                            // placeholder="Order number"
                        />
                    </Col>
                </Row>
                <Row>

                    <Col xs={9} sm={4} md={4} lg={3} className="top10">
                        <ControlLabel>From Date Range Worked</ControlLabel>
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                  onChange={(option) => {
                                      var isSameDate =  moment(this.state.filterOptions['fromDateWorked']).isSame(option, 'day')
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              fromDateWorked: option,
                                          }
                                      }, function () {
                                          if (!isSameDate) {
                                              this.props.search();
                                          }
                                      });
                                  }}
                                  value={this.state.filterOptions.fromDateWorked}
                            // inputProps={{placeholder: 'From FD'}}
                        />
                    </Col>
                    <Col xs={9}  sm={4}  md={4} lg={3}  className="top10">
                        <ControlLabel>To Date Range Worked</ControlLabel>
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                  onChange={(option) => {
                                      var isSameDate =  moment(this.state.filterOptions['toDateWorked']).isSame(option, 'day')
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              toDateWorked: option,
                                          }
                                      }, function () {
                                          if (!isSameDate) {
                                              this.props.search();
                                          }
                                      });
                                  }}
                                  value={this.state.filterOptions.toDateWorked}
                                  // inputProps={{placeholder: 'To FD'}}
                        />
                    </Col>
                    <Col xs={9} sm={4} md={4} lg={3} className="top10">
                        <ControlLabel>From Paid Date</ControlLabel>
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                  onChange={(option) => {
                                      var isSameDate =  moment(this.state.filterOptions['fromPD']).isSame(option, 'day')
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              fromPD: option,
                                          }
                                      }, function () {
                                          if (!isSameDate) {
                                              this.props.search();
                                          }
                                      });
                                  }}
                                  value={this.state.filterOptions.fromPD}
                         />
                    </Col>
                    <Col xs={9} sm={4} md={4} lg={3} className="top10">
                        <ControlLabel>To Paid Date</ControlLabel>
                        <Datetime dateFormat={'MM-DD-YYYY'} timeFormat={'HH:mm'}
                                  onChange={(option) => {
                                      var isSameDate =  moment(this.state.filterOptions['toPD']).isSame(option, 'day')
                                      this.setState({
                                          'filterOptions': {
                                              ...this.state.filterOptions,
                                              toPD: option,
                                          }
                                      }, function () {
                                          if (!isSameDate) {
                                              this.props.search();
                                          }
                                      });
                                  }}
                                  value={this.state.filterOptions.toPD}
                        />
                    </Col>
                    </Row>
                    <Row>


                        <Col xs={9} sm={4} md={4} lg={3} className="top10">
                            <ControlLabel>Location</ControlLabel>
                            <Select
                                tabIndex="0"
                                multi
                                clearable={false}
                                placeholder=""
                                options={   _.map(config.warehouseData, item => {
                                    return {value: item.MarketName, label: item.MarketName}
                                })}
                                onChange={this.onMarketsSelect.bind(this)}
                                value={self.state.filterOptions.Markets}
                            />
                        </Col>
                    <Col xs={12} sm={6} md={3} lg={3} className=" top20 pbot10  ">

                        <Button className="btn btn-primary top16 pull-left" disabled={this.props.pending} onClick={(event) => self.props.search({})}
                                type="button">
                            SEARCH
                        </Button>
                        <button className="pull-right  btn btn-primary top16 left20 pull-left"
                                onClick={(event) => this.resetSearchParams()}
                                type="button">
                            RESET
                        </button>
                    </Col>
                </Row>
                {this.state.advancedOptionsVisible &&
                <Row className="">
                    {this.props.adminTransactions.fetched && this.props.adminTransactions.total > 0   &&
                    <div className="left15  top20 pull-left right20">
                        <Button className="btn btn-primary top16" onClick={this.onSelectAllRecordsChange.bind(this)}>
                            {this.props.adminTransactions.selectedTransactions.length == 0 ? 'Select all' : 'Clear selection' }
                        </Button>
                    </div>

                    }
                    <Col xs={6} sm={4} md={3} lg={2} className=" top10">
                        <ControlLabel>Deleted</ControlLabel>
                        <Select
                            tabIndex="0"
                            clearable={true}
                            placeholder=""
                            options={[
                                {value: 'true', label: 'Deleted'},
                                // {value: 'false', label: 'Active'}
                                ]}
                            onChange={(option) => {
                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        Deleted:option ?  option.value : false,
                                    }
                                }, function () {
                                    this.props.search();
                                });
                            }}
                             value={self.state.filterOptions.Deleted}
                        />
                    </Col>
                    <Col xs={6} sm={4} md={3} lg={2} className="top10">
                        <ControlLabel>Per Page</ControlLabel>
                        <Select
                            tabIndex="0"
                            placeholder="Per Page"
                            clearable={false}
                            options={config.perPageSelectOptions}
                            onChange={(option)=>{ this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}}, function () {
                                this.props.search();
                            })}}
                            value={self.state.filterOptions.perPage}
                        />
                    </Col>


                </Row>
                }
                <Row className="top20">
                    <Col md={4} xs={4} className="top10">
                        <Button className="btn btn-primary"
                                onClick={ () => this.setState({advancedOptionsVisible: !this.state.advancedOptionsVisible})}>
                            Advanced Options
                        </Button>
                    </Col>
                </Row>


            </div>
        );
    }
}



